import { Injectable } from '@angular/core';
import { SealMockApiService } from '@shipsfocus/seal';
import { portcallStatuses as portcallStatusesData } from 'app/mock-api/port-operation/portcall/data';
import cloneDeep from 'lodash-es/cloneDeep';

@Injectable({
  providedIn: 'root'
})
export class PortcallMockApi {
  private _portcallStatuses: { id: string; index: number; name: string; slug: string }[] = portcallStatusesData;

  constructor(private _sealMockApiService: SealMockApiService) {
    this.registerHandlers();
  }

  registerHandlers(): void {
    this._sealMockApiService.onGet('api/terminal_operation/portcall/statuses').reply(() => {
      const portcallStatuses = cloneDeep(this._portcallStatuses);

      return [200, portcallStatuses];
    });
  }
}
